import React from 'react';
import EpisodeGalleryCard from 'cms/components/items/EpisodeGalleryCard';

export default function EpisodeGalleryCardsWidget({ items, showDelete, onAfterDelete }) {
  if (items === false || items === null || items === undefined) {
    return null;
  }
  const list = Array.isArray(items) ? items : [];
  if (list.length === 0) {
    return <p className="text-muted mb-0">No episodes yet.</p>;
  }

  return (
    <div className="talent-cards-grid episode-gallery-cards-grid">
      {list.map((item, index) => (
        <div
          key={item.id}
          className="talent-card-col"
          style={{ animationDelay: `${Math.min(index, 20) * 45}ms` }}
        >
          <EpisodeGalleryCard
            item={item}
            showDelete={showDelete}
            onAfterDelete={onAfterDelete}
          />
        </div>
      ))}
    </div>
  );
}
